// LOAD ALL THE READ ONLY DATA
import { makeSetReducer } from "./utils";

export const paisesFullfilledReducer = makeSetReducer(['paises/fullfilled']);
